<template>
    <div>
        <app-overlay-loader v-if="!dataLoaded" />
        <div v-else class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-7 d-flex align-items-start">
                    <app-breadcrumb :button="{ label: $t('back'), url: urlGenerator(`crm/gantt/list`) }"
                        :directory="[$t('contacts'), name]" :icon="'users'" :page-title="name" />

                        <div class="ml-5 mt-2 hide-mobile" v-if="formData.gantt_type.name">
                            <span class="badge badge badge-secondary badge-pill mr-2">{{formData.gantt_type.name}}</span>
                        </div>
                        <div class="ml-3 mt-2 hide-mobile d-flex align-items-start mr-2" v-if="lesonDate.start">
                            <app-icon name="calendar" width="20px" height="20" size="1" class=" ml-3 mr-2" />
                            <span>{{ lesonDate.start }} - {{ lesonDate.end }}</span>
                        </div>
                        
                </div>
                <div class="col-sm-12 col-md-5">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          
          <button
            type="button"
            class="btn btn-success mr-3 btn-with-shadow"
            data-toggle="modal"
            @click="changeDate()"
          >
            {{ $t("gantt_change_date") }}
          </button>
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openModal()"
          >
            {{ $t("add_gantt_leson") }}
          </button>
        </div>
      </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card card-with-shadow border-0">
                        <div class="card-body p-0">
                            <app-overlay-loader v-if="preLoader" />
                            <div class="datatable" v-else>
                                <div class=" custom-scrollbar shadow pt-0">
                                    <div class="datatable pb-primary table-wrap">
                                        <table class="table mb-0">
                                            <thead>
                                                <tr class="sticky-row">
                                                    <th class="datatable-th  text-left sticky-col first-col">
                                                        <span class="font-size-default">
                                                            <span class="btn d-flex justify-content-start font-weight-bold">
                                                                <span>{{ $t('gantt_title') }}</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="datatable-th text-center ">
                                                        <span class="font-size-default">
                                                            <span
                                                                class="btn d-flex justify-content-center font-weight-bold">
                                                                <span>{{ $t('gantt_collaborator') }}</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="datatable-th text-center border-left ">
                                                        <span class="font-size-default">
                                                            <span
                                                                class="btn d-flex justify-content-center font-weight-bold">
                                                                <span>{{ $t('gantt_rest') }}</span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th class="datatable-th text-left border-left  py-3 px-2"
                                                        v-for="(item, index) in lesonDate.date" :key="index">
                                                        <span class="font-size-default">
                                                            <span
                                                                class="btn d-flex justify-content-center font-weight-bold">
                                                                <span class="gantt-rotate"><small><b>{{ item }}</b></small></span>
                                                            </span>
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <draggable tag="tbody" 
                                            @change="posChanged" 
                                            v-model="lesons" 
                                            animation="150" 
                                            @end="dragEnd"
                                            group="tasks">
                                                <tr v-for="(ganttItem, index) in lesons" :key="'one-item' + index">
                                                    <td class="datatable-td gantt-tab-title text-nowrap p-0 m-0  sticky-col first-col">
                                                        <div class="d-flex justify-content-start align-items-center leson-name">
                                                            <app-icon name="more-vertical" width="20px" height="20"
                                                                class="cursor-grab ml-3 mr-2" />

                                                            <div class="gantt-check mr-2">
                                                                <div class="customized-checkbox checkbox-default">
                                                                    <input type="checkbox" :name="'status-' + ganttItem.id"
                                                                        :id="'status-' + ganttItem.id"
                                                                        :checked="ganttItem.status_id === 15 || ganttItem.status_id === 16"
                                                                        @change="changeStatus(ganttItem)" />
                                                                    <label :for="'status-' + ganttItem.id"></label>
                                                                </div>
                                                            </div>
                                                            <a href class="text-muted leson-delete"
                                                                @click.prevent="deleteModal(ganttItem.id)">
                                                                <app-icon name="trash-2" width="20px" height="20"/>
                                                            </a>
                                                            <a href
                                                                @click.prevent="editModal(ganttItem.id)">
                                                                <small class="mr-2">{{ ganttItem.name }}</small>
                                                            </a>
                                                        </div>
                                                    </td>
                                                    <td class="datatable-td text-nowrap p-0 m-0 pl-2 pr-2">
                                                        <image-group v-if="ganttItem.collaborator.length"
                                                            :value="ganttItem.collaborator" />
                                                        <div class="d-flex align-items-center justify-content-center"
                                                            v-else>
                                                            <span>-</span>
                                                        </div>
                                                    </td>
                                                    <td class="datatable-td text-nowrap p-0 m-0 border-left pl-2 pr-2">
                                                        <div v-if="ganttItem.rest"
                                                            class="media d-flex align-items-center py-1">
                                                            <div class="avatars-group-w-30">
                                                                <!---<img class="rounded-circle"
                                                                    v-if="ganttItem.rest.profile_picture.length"
                                                                    :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }"
                                                                    :src="ganttItem.rest.profile_picture.path"
                                                                    :alt="ganttItem.rest.full_name">-->
                                                                <div class="no-img rounded-circle"
                                                                    :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }">
                                                                    <small>{{ ganttItem.rest.name ?
                                                                        ganttItem.rest.name : 'AV' | titleFilter
                                                                    }}</small>
                                                                </div>
                                                            </div>
                                                            <div class="media-body ml-2">
                                                                <small v-if="ganttItem.price > 0">{{ numberWithCurrencyMuseum(ganttItem.price) }}
                                                                    </small>
                                                                <p class="text-muted font-size-70 mb-0"
                                                                    :class="(ganttItem.price > 0) ? 'gantt-price-name' : 'gantt-price'">
                                                                    {{ ganttItem.rest.name }}</p>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div v-if="ganttItem.price > 0" class="media d-flex align-items-center py-1">
                                                                <small>{{ numberWithCurrencyMuseum(ganttItem.price) }}</small>
                                                            </div>
                                                            <div class="d-flex align-items-center justify-content-center"
                                                            v-else>
                                                            <span>-</span>
                                                        </div>
                                                        </div>
                                                    </td>
                                                    <template v-for="(item, index) in lesonDate.date">
                                                        <td class="align-items-stretch p-0 m-0 align-items-center border-left date-active"
                                                        :class="[calcDate(item, ganttItem), { 'show': ganttItem.id === selectedGanttItemId && index === selectedGanttItemIndex}]" :key="index"
                                                            @click="showDesc(ganttItem.id, index)"
                                                            >
                                                            <div class="leson-desc px-3 py-2 ml-2" v-if="ganttItem.description">
                                                                <span><small>{{ ganttItem.description }}</small></span>
                                                            </div>
                                                        </td>
                                                    </template>
                                                </tr>
                                            </draggable>
                                            <tbody class="border-gantt-footer">
                                                <tr>
                                                    <td class="datatable-td pt-4 gantt-tab-title text-nowrap p-0 m-0  sticky-col first-col">
                                                        <a href class=""
                                                                @click.prevent="openModal()">
                                                                <small class="ml-4">{{ $t('add_gantt_task') }}</small>
                                                            </a>
                                                        
                                                    </td>
                                                    <td class="datatable-td pt-4 text-nowrap p-0 m-0 pl-2 pr-2">
                                                        <image-group v-if="collaborators"
                                                            :value="collaborators" />
                                                        <div class="d-flex align-items-center justify-content-center"
                                                            v-else>
                                                            <span>-</span>
                                                        </div>
                                                    </td>
                                                    <td class="datatable-td pt-4 text-nowrap p-0 m-0 pl-2 pr-2">
                                                        <div v-if="summ > 0"
                                                            class="media d-flex align-items-center py-1">
                                                            <small>{{ numberWithCurrencyMuseum(totalPrice) }}</small>
                                                        </div>
                                                        <div class="d-flex align-items-center justify-content-center" v-else>
                                                            <span>{{ numberWithCurrencyMuseum(0) }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-leson-modal
      v-if="ganttModal"
      :table-id="'leson'"
      :gantt-id="formData.id"
      :start="lesonDate.start"
      :end="lesonDate.end"
      :selected-url="lesonUrl"
      @close-modal="closeModal"
      @update-request="updateRequest"
    />




        <app-change-date-modal
      v-if="changeModal"
      :table-id="'leson'"
      :start="lesonDate.start"
      :selected-url="selectedUrl"
      @close-modal="closeChangeModal"
      @update-request="updateRequest"
    />
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="lesonl"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
    </div>
</template>

<script>
import { FormMixin } from "@core/mixins/form/FormMixin.js";
import { formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import draggable from 'vuedraggable';
import moment from "moment";
export default {
    props: ["selectedUrl"],
    name: "PersonDetails",
    mixins: [FormMixin],
    components: { draggable },


    data() {
        return {
            numberWithCurrencyMuseum,
            urlGenerator,
            dataLoaded: false,
            confirmationModalActive:false,
            name: '',
            lesonUrl: '',
            formData: {},

            editedUrl: "",
            formatDateToLocal,
            onlyTimeFromTime,
            onlyTime,
            textTruncate,
            shadow: true,
            border: true,
            selectedGanttItemId: null,
            selectedGanttItemIndex: null,
            ganttModal: false,
            date: [
                
            ],
            collaborators: [],
            summ: 1200.00,
            formDataLeson: {},
            moved: '',
            lesons: '',
            preLoader: true,
            lesonDate: {
                date: [],
                start:'',
                end:'',
            },
            changeModal: false,

        };
    },
    computed: {
        peopleList() {
            return this.$store.getters.getPerson
        },
        totalPrice() {
        const sum = this.lesons.reduce((total, item) => total + Number(item.price), 0);
        return sum.toFixed(2);
  },


    },
    methods: {
        changeDate(){
            this.changeModal = true;
        },
        closeChangeModal() {
            this.changeModal = false;
            console.log('close');
            $("#change-modal").modal("hide");
        },
        afterSuccessFromGetEditData(response) {
            this.formData = response.data;
            this.name = response.data.name;
            this.dataLoaded = true;
            //this.getLeson(response.data.id);
            this.getDate(response.data.id);
        },
        getLeson(id) {
            //this.preLoader = true;
            this.axiosGet('/crm/leson/' + id)
                .then((res) => {
                    this.lesons = res.data;
                })
                .finally(() => {
                    let allCollaborators = [];

                    this.lesons.forEach(item => {
                        item.collaborator.forEach(collaborator => {
        if (!allCollaborators.some(existingCollaborator => existingCollaborator.id === collaborator.id)) {
            allCollaborators.push(collaborator);
        }
    });
});
this.collaborators = allCollaborators;
                    this.preLoader = false;
                });
        },
        getDate(id) {
            //this.preLoader = true;
            this.axiosGet('/crm/lesondate/' + id)
                .then((res) => {
                    this.lesonDate = res.data;
                })
                .finally(() => {
                    this.getLeson(id);
                });
        },
        changeStatus(item) {
            console.log(item);
            this.formDataLeson.id = item.id;
            this.formDataLeson.name = item.name;
            this.formDataLeson.gantt_id = item.gantt_id;
            this.formDataLeson.created_by = item.created_by;

            if(item.status_id == 15 || item.status_id == 16){
                this.formDataLeson.status_id = '14';
            }else{
                this.formDataLeson.status_id = '15';
            }
            
            this.axiosPatch({
          url: 'crm/lesons/' + this.formDataLeson.id,
          data: this.formDataLeson,
        }).then((response) => { 
            this.$toastr.s(response.data.message);
          this.formDataLeson = {}; 
        }).catch((er) => console.log(er)).finally(() => {
            this.updateRequest();
        });

        },
        setDate(date){
            return moment(date, "DD.MM.YYYY").format('DD.MM');
        },
        calcDate(item, ganttItem) {
            let date = moment(item, "DD.MM.YYYY");
            let start = moment(ganttItem.formatted_started_at, "DD.MM.YYYY");
            let end = moment(ganttItem.formatted_ended_at, "DD.MM.YYYY");
            if (date >= start && date <= end) {
                let status = (ganttItem.status_id == 14) ? 'gantt-todo' : (ganttItem.status_id == 15 ? 'gantt-done' : 'gantt-lose');
                return 'active ' + status + ' date-id-' + ganttItem.id;
            }
        },

        
        updateRequest() {
            this.getDate(this.formData.id);
            
        },
        posChanged(evt) {
            //console.log(evt);
            const itemsWithIndices = this.lesons.map((item, index) => ({
    id: item.id,
    sort: index,
  }));

  console.log('Items with indices:', itemsWithIndices);
            //this.moved = evt.moved;
            //this.oldIndex = evt.moved.oldIndex;
            //this.newIndex = evt.moved.newIndex;
            //this.element = evt.moved.element.id;

            //console.log(evt.moved);
            //console.log(evt);
      this.formDataLeson.id = evt.moved.element.id;
      this.formDataLeson.name = evt.moved.element.name;
      this.formDataLeson.gantt_id = evt.moved.element.gantt_id;
      this.formDataLeson.created_by = evt.moved.element.created_by;
      this.formDataLeson.change = itemsWithIndices;

      //this.formDataLeson.sort = evt.moved.newIndex;


      //console.log(this.formDataLeson);
    
        this.axiosPatch({
          url: 'crm/lesons/' + this.formDataLeson.id,
          data: this.formDataLeson,
        }).then((response) => { 
            this.$toastr.s(response.data.message);
          this.formDataLeson = {}; 
        }).catch((er) => console.log(er)).finally(() => {
            
        });

        },
        dragEnd(evt) {
           
   
    },


        openModal() {
      this.ganttModal = true;
    },
        editModal(id) {
      this.ganttModal = true;
      this.lesonUrl = `crm/lesons/${id}`;
    },
        deleteModal(id) {
            this.deleteUrl = `crm/lesons/${id}`;
        this.confirmationModalActive = true;
    },
    closeModal() {
      this.ganttModal = false;
      this.lesonUrl = "";
      $("#leson-modal").modal("hide");
    },
    confirmed() {
            this.axiosDelete(this.deleteUrl).then((response) => {
                this.$toastr.s(response.data.message);
                this.updateRequest();
                this.cancelled();
            }).catch(({error}) => {
            });
        },
        cancelled() {
            this.confirmationModalActive = false;
            this.deleteUrl = "";
        },




        showDesc(id, index) {
    this.selectedGanttItemId = id;
    this.selectedGanttItemIndex = index;
    /*setTimeout(() => {
      this.selectedGanttItemId = null;
      this.selectedGanttItemIndex = null;
    }, 4000);*/
  },

  





    },

    mounted() {

        this.$store.dispatch("getPersonRest");
        this.$store.dispatch("getOwner");

    },

    filters: {
        titleFilter(str) {
            str = str.replace(/(^\s*)|(\s*$)/gi, "");
            str = str.replace(/[ ]{2,}/gi, " ");
            str = str.replace(/\n /, "\n");
            let titleArray = str.split(' ');
            if (titleArray.length > 1) {
                return (titleArray[0][0] + titleArray[1][0]).toLocaleUpperCase();
            } else {
                return titleArray[0].substring(0, 2).toLocaleUpperCase();
            }
        },
    }
};
</script>
<style scoped>



.leson-delete {
    display: none;
}
.leson-name:hover .leson-delete {
    display: block;
}





.gantt-check {
    width: 20px;
    height: 20px;
}

.date-active{
    position: relative;
}
.leson-desc {
    display: none;
    position:absolute;
    bottom: 30px;
    width:200px;
    padding: 5px;
    background: #fff;
    border-radius: 5px;
    z-index:5;
    box-shadow: 0px 1px 5px #ccc;
}
.date-active.active.show .leson-desc {
    display: block;
}
.date-active.active.gantt-todo {
    background: #838383;
}

.date-active.active.gantt-done {
    background: #46c35f;
}

.date-active.active.gantt-lose {
    background: #da0037;
}

.gantt-tab-title {
    min-width: 300px;
}

.gantt-tab-title-text {
    width: 270px;
    overflow: hidden;
}

.gantt-price-name {
    margin-top: -4px;
}

.gantt-rotate {
    writing-mode: vertical-lr;
    transform: rotate(-180deg);
}
</style>
